import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
// import { DashboardComponent } from './dashboard.component';
import { YearlyComponent } from './yearly/yearly.component';
import { MonthlyComponent } from './monthly/monthly.component';
import { CoreModule } from '../core/core.module';
import { DashboardService } from './dashboard.service';
import { DashboardComponent } from './dashboard.component';
import { DashboardStatisticsComponent } from './dashboard-statistics/dashboard-statistics.component';
import { ContractorDashboardComponent } from './contractor-dashboard/contractor-dashboard.component';
// tslint:disable-next-line: max-line-length
import { ContractorDashboardGroupRowComponent } from './contractor-dashboard/contractor-dashboard-group-row/contractor-dashboard-group-row.component';
// import { ReportsGridWrapperComponent as ReportsGridWrapperComponentLabourcgmp} from '../labour/labour-cgmp-training/reports-grid-wrapper/reports-grid-wrapper.component';
import { ReportsGridWrapperComponent } from './reports-grid-wrapper/reports-grid-wrapper.component';

@NgModule({
  declarations: [
    DashboardComponent,
    YearlyComponent,
    MonthlyComponent,
    DashboardStatisticsComponent,
    ContractorDashboardComponent,
    ContractorDashboardGroupRowComponent,
    ReportsGridWrapperComponent,
    // ReportsGridWrapperComponentLabourcgmp
  ],
  imports: [
    CommonModule,
    CoreModule.forRoot(),
    DashboardRoutingModule
  ],
  providers: [
    DashboardService,
    DatePipe,
  ],
  entryComponents:[ContractorDashboardGroupRowComponent],
  exports: [
    DashboardRoutingModule,
    DashboardComponent,
    ContractorDashboardComponent
  ]
})
export class DashboardModule { }
